import React from 'react'
import { i18nTranslate } from 'src/utils'
import isEmpty from 'lodash/isEmpty'
import { Row, Col, Form, Dropdown, Button } from 'react-bootstrap'
import {
  IoIosArrowDown as ArrowDownIcon,
  IoIosSearch as SearchIcon,
} from 'react-icons/io'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { getFilterParams, constructQueryParam } from 'src/deps'
import { searchDate, orderFilterStatus } from './fixture'

@observer
class OrderSearch extends React.Component {
  @observable
  selectedStatus = this.props.selectedStatus
  @observable
  selectedDate = this.props.selectedDate
  @observable
  selectedOrderId = this.props.selectedOrderId
  @observable
  queryParams = {}

  getOrderSearchInput = () => {
    const refine = this.props.location?.queryParams?.refine || ''

    try {
      const refineParams = refine ? JSON.parse(refine) : {}
      return refineParams.refine?.orderId || ''
    } catch (e) {
      console.error('JSON.parse may be an error >>> getOrderSearchInput ', e)
      return ''
    }
  }

  componentDidUpdate() {
    this.selectedStatus = this.props.selectedStatus
    this.selectedDate = this.props.selectedDate
    if (this.orderSearchInput) {
      this.orderSearchInput.value = this.getOrderSearchInput()
    }
  }

  handleOrderIdDeletion = queryParams => {
    try {
      const response = !isEmpty(queryParams) && JSON.parse(queryParams.refine)
      const params = !isEmpty(response) && Object.keys(response.refine)
      params &&
        params.indexOf('orderId') !== -1 &&
        delete response.refine.orderId
      return response
    } catch (e) {
      console.error('JSON.parse may be an error >>> handleOrderIdDeletion ', e)
      return {}
    }
  }

  handleQueryParam = data => {
    const refine = {
      refine: {},
    }
    this.selectedOrderId = ''
    const queryParams = getFilterParams(location)
    const response = this.handleOrderIdDeletion(queryParams)
    const refineParamsFromURL = response.refine ? response : refine

    const dataKey = Object.keys(data)
    const dataValue = Object.values(data)

    if (dataValue[0] !== '') {
      refineParamsFromURL.refine[dataKey[0]] = dataValue[0]
    } else {
      delete refineParamsFromURL.refine[dataKey[0]]
    }

    if (isEmpty(refineParamsFromURL.refine)) {
      return ''
    }
    queryParams.refine = JSON.stringify(refineParamsFromURL)
    return queryParams
  }
  onSubmitDate = async event => {
    event.persist()
    this.selectedDate = event.target.textContent
    const dateQuery = this.handleQueryParam({ dateLimit: event.target.value })
    this.props.toggleAccordionView()
    constructQueryParam(this.props, dateQuery)
  }

  onSubmitStatus = async event => {
    event.persist()
    this.selectedStatus = event.target.textContent
    const statusQuery = this.handleQueryParam({ status: event.target.value })
    this.props.toggleAccordionView()
    constructQueryParam(this.props, statusQuery)
  }

  handleSearchOrder = async event => {
    event.preventDefault()
    event.persist()
    const orderId = event?.target?.firstChild?.value
    this.selectedStatus = 'All'
    this.selectedDate = 'All'
    const queryParams = {
      refine: JSON.stringify({
        refine: {
          orderId,
        },
      }),
    }
    const setQueryParam = orderId ? queryParams : {}
    this.props.toggleAccordionView()
    constructQueryParam(this.props, setQueryParam)
  }

  renderMenuItem = (item, index, handleOnClick) => {
    const { key = '', value = '', dataTestId = 'qa-dropdown-lists' } = item
    return (
      <Dropdown.Item
        as="button"
        onClick={handleOnClick}
        disabled={key === this.selectedStatus}
        key={index}
        value={value}
        data-testid={dataTestId}>
        {key}
      </Dropdown.Item>
    )
  }
  handleChangeData = event => {
    this.selectedOrderId = event.target.value || ''
  }

  render() {
    return (
      <Row
        noGutters
        className="order-search-form-container justify-content-between align-items-end">
        <Col lg={6} md={12} className="col-padding">
          <Form
            className="order-search-box position-relative"
            onSubmit={this.handleSearchOrder}
            data-testid="qa-order-search-textbox">
            <Form.Control
              ref={element => (this.orderSearchInput = element)}
              type="text"
              value={this.selectedOrderId}
              onChange={this.handleChangeData}
              placeholder={i18nTranslate(
                'orders.searchAll',
                'Search all orders'
              )}
              aria-label={i18nTranslate(
                'orders.searchAll',
                'Search all orders'
              )}
              data-testid="qa-order-search-input-box"
            />
            <Button
              className="position-absolute bg-transparent border-0 p-0 order-search-button"
              type="submit"
              aria-label="clickable search icon"
              data-testid="qa-order-search-button">
              <SearchIcon fill="#000" className="order-search-icon" />
            </Button>
          </Form>
        </Col>

        <Col lg={3} md={6} xs={6} className="col-padding">
          <label
            aria-label="true"
            className="order-search-form-label w-100 m-0 text-truncate heading-5"
            data-testid="qa-order-date-title">
            {i18nTranslate('orderSearch.date', 'Order Date')}
          </label>
          <Dropdown className="order-search-box">
            <Dropdown.Toggle
              className="order-search-toggle w-100 d-flex align-items-center justify-content-between"
              variant=""
              data-testid="qa-order-date-dropdown">
              <span
                className="order-search-dropdown-text text-capitalize"
                data-testid="qa-order-selected-date">
                {this.selectedDate}
              </span>
              <span
                className="order-search-dropdown-arrow justify-content-center align-items-center d-flex"
                data-testid="qa-order-date-dropdown-arrow">
                <ArrowDownIcon
                  aria-label={i18nTranslate(
                    'orders.toggle',
                    'Toggle search box'
                  )}
                />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-100 z-1" flip={false}>
              {searchDate.map((item, index) => {
                return this.renderMenuItem(item, index, this.onSubmitDate)
              })}
            </Dropdown.Menu>
          </Dropdown>
        </Col>

        <Col lg={3} md={6} xs={6} className="col-padding">
          <label
            className="order-search-form-label w-100 m-0 text-truncate heading-5"
            data-testid="qa-order-status-title">
            {i18nTranslate('orderSearch.status', 'Order Status')}
          </label>
          <Dropdown className="order-search-box  order-status-dropdown">
            <Dropdown.Toggle
              className="order-search-toggle w-100 d-flex align-items-center justify-content-between"
              variant=""
              data-testid="qa-order-status-dropdown">
              <span
                className="order-search-dropdown-text text-capitalize"
                data-testid="qa-order-selected-status">
                {this.selectedStatus}
              </span>
              <span
                className="order-search-dropdown-arrow justify-content-center align-items-center d-flex"
                data-testid="qa-order-status-dropdown-arrow">
                <ArrowDownIcon
                  aria-label={i18nTranslate(
                    'orders.toggle',
                    'Toggle search box'
                  )}
                />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="z-1" dataTestId="qa-dropdown">
              {orderFilterStatus.map((item, index) => {
                return this.renderMenuItem(item, index, this.onSubmitStatus)
              })}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
    )
  }
}

export default OrderSearch
export { OrderSearch }
